import { Injectable } from '@angular/core';

import { forkJoin, map, Observable, of, tap } from 'rxjs';
import { UsersService } from './users.service';
import { User } from '../../core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class UsersResolver {
    constructor(private users: UsersService) {
    }

    resolve(): Observable<User[]> {
        return this.users.getAllUsers();
    }
}
